theme.witnessesSwiper = (function() {
  document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".influencers-carousel");
  const next = document.querySelector(".next-btn");
  const prev = document.querySelector(".prev-btn");

  const scrollAmount = 380;

  next.addEventListener("click", () => {
    carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  prev.addEventListener("click", () => {
    carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });
});
});
// ...
theme.witnessesSwiper();